import { Component, OnInit, Inject, Input, OnChanges, OnDestroy } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  ValidateInputService,
  Address,
  messageErrorDirection,
  getIdAddress,
  AuthService,
  Constants,
  LocationsService,
  isMobile
} from '../../../core';
import { SnackbarService } from '../snackbar/snackbar.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Point } from '../..';
interface HistoryAddress {
  ubigeoCode: any;
  address: string;
  number: string;
  active: boolean
}
interface CustomerInformation {
  id: string;
  addresses: Address[];
}

interface Location {
  department: string;
  province: string;
  district?: string;
}
@Component({
  standalone: false,
  selector: 'app-add-address',
  templateUrl: './form-add-address.component.html',
  styleUrls: ['./form-add-address.component.scss']
})
export class FormAddAddressComponent implements OnInit, OnChanges, OnDestroy {
  public isMobile = isMobile();
  public isHistorial = false;
  public myValidate: FormGroup;
  public validation_messages;
  public addressType: any[] = Constants.Customer.ADDRESS_TYPES.getProps();
  public historyAddress: HistoryAddress[];
  public dataAddress: Address[];
  public address: Address[];
  public activeGeo = true;
  public stateButton = false;
  public pointGeolocation: Point;
  public aliasGeolocation: string;
  public store: any;
  public floorEntity: number;
  public floorEntityMessage: string;
  public titles = { title: 'Direcciones', titleButton: 'Aceptar' };
  public pattern: RegExp = /^([a-zA-Z'áéíóúñüÁÉÍÓÚÑÜ'0-9\s\'\-\.])+$/;
  typeSend = Constants.SaleConfig;
  public componentLocations: Location;
  zoneIds: string;
  isEditDispatch = false;
  isEditDispatchLoaded = false;
  private onDestroy$: Subject<void> = new Subject<void>();
  addressTemp: string;
  numberTemp: string;
  editDistrict: boolean = false;
  constructor(
    fb: FormBuilder,
    public snackbarService: SnackbarService,
    public validateService: ValidateInputService,
    public authService: AuthService,
    public dialogRef: MatDialogRef<FormAddAddressComponent>,
    public locationsService: LocationsService,
    @Inject(MAT_DIALOG_DATA) public customerInformation: CustomerInformation
  ) {
    this.myValidate = fb.group({
      stateAddress: false,
      fullAddress: null,
      ubigeoCode: [null, [Validators.required]],
      wayType: 'AVENUE',
      latitude: [null, [Validators.required]],
      longitude: [null, [Validators.required]],
      address: ['', [Validators.required, Validators.minLength(4)]],
      departmentNumber: [''],
      floor: [1, [Validators.required, Validators.max(50), Validators.min(1)]],
      number: ['', [Validators.required]],
      department: [null, [Validators.required]],
      province: [null, [Validators.required]],
      district: ['', [Validators.required]],
      reference: ['', [Validators.required]],
      addressType: ['HOME'],
      zoneId: null,
      active: true
    });
    this.isEditDispatch = this.customerInformation.id === 'editDispatch';
    if (this.isEditDispatch) {
      this.titles.title = 'Modificar Dirección de Despacho';
    }
  }

  ngOnChanges() {}

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  ngOnInit() {
    this.validation_messages = messageErrorDirection;
    this.listAlias();
    this.myValidate.get('fullAddress').valueChanges.subscribe(change => {
      if (change !== 'new') {
        const data = this.dataAddress;
        const addressArray = data.filter(
          item =>
            item.ubigeoCode + item.address + item.number === change
        );
        this.addFormMyValidate(addressArray[addressArray.length - 1]);
      } else {
        this.myValidate.get('stateAddress').patchValue(false);
        this.myValidate.get('ubigeoCode').patchValue('');
        this.myValidate.get('department').patchValue('');
        this.myValidate.get('province').patchValue('');
        this.myValidate.get('district').patchValue('');
        this.myValidate.get('active').patchValue(true);
        this.cleanAddressFields();
        this.componentLocations = this.dataLocations();
        this.zoneIds = null;
      }
    });

    this.myValidate.get('address').valueChanges.subscribe(change => {
      if (this.myValidate.get('fullAddress').value !== 'new' && this.addressTemp !== change && this.myValidate.dirty) {//
        this.myValidate.get('latitude').setValue(null);
        this.myValidate.get('longitude').setValue(null);
        this.addressTemp = change;
      }
    });
    this.myValidate.get('number').valueChanges.subscribe(change => {
      if (this.myValidate.get('fullAddress').value !== 'new' && this.numberTemp !== change && this.myValidate.dirty) { //
        this.myValidate.get('latitude').setValue(null);
        this.myValidate.get('longitude').setValue(null);
        this.numberTemp = change;
      }
    });

    this.myValidate.valueChanges.subscribe(data => {
      this.address = data;
      if (data.address && data.district && data.number) {
        if (data.ubigeoCode) {
          this.activeGeo = false;
        } else {
          this.activeGeo = true;
        }
      }
      this.myValidate.markAsPristine({onlySelf: false});
    });

    this.componentLocations = this.dataLocations();
    this.floorStore();
    this.myValidate.get('fullAddress').setValue(
      this.customerInformation.addresses.length
        ? getIdAddress(this.customerInformation.addresses[
          this.customerInformation.addresses.length - 1
        ])
        : 'new'
    );
  }

  cleanAddressFields() {
    this.zoneIds = null;
    this.myValidate.get('latitude').patchValue(null);
    this.myValidate.get('longitude').patchValue(null);
    this.myValidate.get('wayType').patchValue('AVENUE');
    this.myValidate.get('addressType').patchValue('HOME');
    this.myValidate.get('address').patchValue('');
    this.myValidate.get('departmentNumber').patchValue('');
    this.myValidate.get('floor').patchValue(1);
    this.myValidate.get('number').patchValue('');
    this.myValidate.get('reference').patchValue('');
    this.myValidate.get('zoneId').patchValue(null);
    this.myValidate.get('active').patchValue(true);
  }

  loadInitForm() {
    this.addFormMyValidate(
      this.customerInformation.addresses[
      this.customerInformation.addresses.length - 1
      ]
    );
  }

  _addZoneOfDepartment(event) {
    if (event) {
      this.myValidate.get('department').setValue(event);
      this.myValidate.get('province').setValue('');
      this.myValidate.get('district').setValue('');
      this.myValidate.get('ubigeoCode').setValue('');
    }
  }

  _addZoneOfProvince(event) {
    if (event.y) {
      this.myValidate.get('department').setValue(event.x.department);
      this.myValidate.get('province').setValue(event.y.province);
      this.myValidate.get('district').setValue('');
      this.myValidate.get('ubigeoCode').setValue('');
    }
  }

  _addAllPlaces(event) {
    if (event.z) {
      if (event.z.id) {
        this.myValidate.get('district').setValue(event.z.district);
        this.myValidate.get('ubigeoCode').setValue(event.z.id);
        if (this.isEditDispatch) {
          if (this.isEditDispatchLoaded) {
            this.cleanAddressFields();
          } else {
            this.isEditDispatchLoaded = true;
          }
        }
      }
      this.updateZone(event.z.id);
    } else {
      this.myValidate.get('district').setValue('');
      this.myValidate.get('ubigeoCode').setValue('');
    }

  }
  dataLocations() {
    return {
      department: this.myValidate.controls['department'].value,
      province: this.myValidate.controls['province'].value,
      district: this.myValidate.controls['district'].value
    };
  }
  // agregar al formulario
  addFormMyValidate(element) {
    this.addressTemp = element.address;
    this.numberTemp = element.number;
    this.myValidate.patchValue({
      stateAddress: true,
      latitude: element.latitude,
      longitude: element.longitude,
      addressType: element.addressType,
      wayType: element.wayType ? element.wayType : 'AVENUE',
      address: element.address,
      departmentNumber: element.departmentNumber,
      floor: element.floor ? element.floor : 1,
      reference: element.reference,
      active: this.isEditDispatch ? true: element.active,
      number: element.number,
      department: element.ubigeo
          ? element.ubigeo.department
          : element.department.name
            ? element.department.name
            : element.department,
      province: element.ubigeo
          ? element.ubigeo.province
          : element.province.name
            ? element.province.name
            : element.province,
      district: element.ubigeo
        ? element.ubigeo.district
        : element.district.name
          ? element.district.name
          : element.district,
      ubigeoCode: element.ubigeoCode,
      zoneId: element.zoneId ? element.zoneId : null
    });
    this.pointGeolocation = {
      lat: element.latitude,
      lng: element.longitude
    };
    this.zoneIds = this.myValidate.get('zoneId').value;
    this.componentLocations = this.dataLocations();
  }

  validateGeolocation() {
    let district = this.myValidate.get('district').value;
    const num = this.myValidate.get('number').value;
    if (typeof district === 'object') {
      district = district.name;
    }
    const alias =
      this.myValidate.get('address').value +
      ' ' +
      num +
      ', ' +
      district +
      ', Perú';
    this.aliasGeolocation = alias;
  }

  locationMarker(event) {
    this.myValidate.get('latitude').setValue(event.lat);
    this.myValidate.get('longitude').setValue(event.lng);
  }

  validateInput(event) {
    this.validateService.validateInput(event);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  newAddress() {
    this.myValidate.get('fullAddress').patchValue('new');
  }

  listAlias() {
    if (this.customerInformation.addresses) {
      this.historyAddress = [];
      this.dataAddress = this.customerInformation.addresses;
      this.dataAddress.forEach(element => {
        this.historyAddress.push({
          ubigeoCode: element.ubigeoCode,
          address: element.address,
          number: element.number,
          active: this.isEditDispatch ? true :element.active
        });
      });
    }
  }

  floorStore() {
    this.store = this.authService.getUser().entity;
    if (this.store.company.code === 'SPSA') {
      this.floorEntity = 2;
    } else {
      this.floorEntity = 4;
    }
    this.floorEntityMessage =
      'Hay restricción de servicio a partir del piso ' + this.floorEntity;
  }

  updateZone(ubigeo) {
    if (ubigeo) {
      this.locationsService
        .getZoneForUbigeo(ubigeo)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(item => {
          const config = item[0].configuredZones;
          if (!config.length) {
            this.validationZone();
          } else {
            this.myValidate.controls['zoneId'].setValue(config[0].zoneId);
          }
        });
    }
  }

  validationZone() {
    if (!this.isEditDispatch || this.isEditDispatch && !this.customerInformation.addresses.length) {
      this.myValidate.get('fullAddress').setValue('new');
    } else {
      this.myValidate.get('district').setValue('');
      this.myValidate.get('ubigeoCode').setValue('');
    }
    this.snackbarService.show(
      'No existe ruta para la dirección ingresada',
      'error'
    );
  }

  editDisrict() {
    this.editDistrict = true;
  }

  removeSpaces(control: string):any {
    return this.myValidate.controls[control].setValue(this.myValidate.controls[control].value
      ? this.myValidate.controls[control].value.trim(): null);
  }
}
